<template>
    <div class="step-template">
        <div :class="`text-wrapper no-app step-${ this.appStep }`">
            <div class="left-wrapper">
                <h1>Ideal für</h1>
    
                <ul>
                    <li>Neu und schon länger diagnostizierte Patientinnen und Patienten</li>
                    <li>Personen, die ihren Lebensstil verbessern möchten</li>
                    <li>Personen, bei denen eine Erhöhung der Medikation ansteht</li>
                </ul>
                <figure>
                    <picture>
                        <img src="/imgs/web/webdemo-doctors/app_step_1_logo.webp" srcset="/imgs/web/webdemo-doctors/app_step_1_logo.webp 1x, /imgs/web/webdemo-doctors/app_step_1_logo@2x.webp 2x">
                    </picture>
                </figure>
                
                <v-button
                    variant="primary"
                    color="green"
                    label="Was sind Ihre Vorteile?"
                    size="lg"
                    @onClick="actualStep()" 
                />
            </div>

            
        </div>

        <figure class="right-wrapper">
                <picture>
                    <img src="/imgs/web/webdemo-doctors/app_step_1.webp" srcset="/imgs/web/webdemo-doctors/app_step_1.webp 1x, /imgs/web/webdemo-doctors/app_step_1@2x.webp 2x">
                </picture>
            </figure>
    </div>
</template>

<script>
export default {

    props: {},
    data(){
        return {
            appStep: 1
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}

</script>

